module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-98.8786c7a8.svg";